import { all, call, put, takeLatest } from "redux-saga/effects"
import API from "../../helpers/sagaApi/sagaApi"
import Actions, { SagaMapTypes } from "./sagaMapRedux"
import AppConfig from "../../configs/AppConfig"
import { confirmClearCart } from "../../helpers/utility"

export function* requestGetProvinces(action) {
  const tag = "[REQUEST_GET_PROVINCES]"
  try {
    // step 1: perform input validation
    const inputValid = true // IDE-Help, do not delete me
    if (inputValid) {
      // step 2 : validation passed..
      const response = yield call(API.requestGetProvinces)
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(`${tag} requestGetProvinces response :`, response.data)
        }
        yield put(Actions.getProvincesSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestGetProvinces failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.getProvincesFailure(message))
  }
}

export function* requestGetDistrictByProvinceId(action) {
  const tag = "[REQUEST_GET_DISTRICT_BY_PROVINCE_ID]"
  try {
    const inputValid = true
    if (inputValid) {
      const response = yield call(
        API.requestGetDistrictByProvinceId,
        action.ProvinceId
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(
            `${tag} requestGetDistrictByProvinceId response :`,
            response.data
          )
        }
        yield put(Actions.getDistrictByProvinceIdSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestGetDistrictByProvinceId failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.getDistrictByProvinceIdFailure(message))
  }
}

export function* requestGetSubDistrictByDistrictId(action) {
  const tag = "[REQUEST_GET_SUB_DISTRICT_BY_DISTRICT_ID]"
  try {
    // step 1: perform input validation
    const inputValid = true // IDE-Help, do not delete me
    if (inputValid) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestGetSubDistrictByDistrictId,
        action.DistrictId
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(
            `${tag} requestGetSubDistrictByDistrictId response :`,
            response.data
          )
        }
        yield put(
          Actions.getSubDistrictByDistrictIdSuccess(response.data.result)
        )
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(
      `${tag} requestGetSubDistrictByDistrictId failed with error :`,
      e
    )
    const message = e.message ? e.message : "Failed"
    yield put(Actions.getSubDistrictByDistrictIdFailure(message))
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(SagaMapTypes.REQUEST_GET_PROVINCES, requestGetProvinces),
    takeLatest(
      SagaMapTypes.REQUEST_GET_DISTRICT_BY_PROVINCE_ID,
      requestGetDistrictByProvinceId
    ),
    takeLatest(
      SagaMapTypes.REQUEST_GET_SUB_DISTRICT_BY_DISTRICT_ID,
      requestGetSubDistrictByDistrictId
    )
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagaMap/sagaMapSaga.ts